import { PaginationMetaData } from './utils';

export const PAGINATION_META_DEFAULT_VALUE: PaginationMetaData = {
  page: 1,
  limit: 10,
  totalResults: 0,
  totalPages: 0,
  firstDocId: '',
  lastDocId: '',
  prevDocId: '',
};
